import BaseListPresenter from "../../../../base/BaseListPresenter";

export default class AccessHistoryListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  init() {
    const user = this.view.getCurrentUser();
    const { id, searchNameId } = this.view.getParams();
    console.log("sss", user);

    console.log("asas", searchNameId);

    this.limit = 20;
    this.where = {
      record: { id: searchNameId },
    };
    this.search = {};
    this.filter = {};
    this.include = ["accessor.affiliate", "accessor.branch", "record"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }
}
